import { Toast } from "../../submodules/rapdv/client/elements/Bootstrap"

export class MessageToast {
  private static CONTAINER_ID = "message-toast-container"
  private static CONTAINER_STYLE = "position:fixed;top:1rem;right:1rem;z-index:1100;min-width:280px;"
  private static AUTOHIDE_DELAY_MS = 8000
  private static ERROR_ICON_CLASS = "bi bi-exclamation-triangle-fill text-danger"

  public static showError = (title: string, message: string): void => {
    MessageToast.show(MessageToast.ERROR_ICON_CLASS, title, message)
  }

  private static show = (iconClass: string, title: string, message: string): void => {
    const container = MessageToast.getOrCreateContainer()

    const toastEl = document.createElement("div")
    toastEl.className = "toast"
    toastEl.setAttribute("role", "alert")
    toastEl.setAttribute("aria-live", "assertive")
    toastEl.setAttribute("aria-atomic", "true")

    const header = document.createElement("div")
    header.className = "toast-header"

    const icon = document.createElement("i")
    icon.className = `${iconClass} me-2`

    const titleEl = document.createElement("strong")
    titleEl.className = "me-auto"
    titleEl.textContent = title

    const closeButton = document.createElement("button")
    closeButton.type = "button"
    closeButton.className = "btn-close"
    closeButton.setAttribute("data-bs-dismiss", "toast")
    closeButton.setAttribute("aria-label", "Close")

    header.append(icon, titleEl, closeButton)

    const body = document.createElement("div")
    body.className = "toast-body"
    body.textContent = message

    toastEl.append(header, body)
    container.appendChild(toastEl)

    const toast = new Toast(toastEl, { autohide: true, delay: MessageToast.AUTOHIDE_DELAY_MS })
    toast.show()
    toastEl.addEventListener("hidden.bs.toast", () => toastEl.remove())
  }

  private static getOrCreateContainer = (): HTMLElement => {
    let container = document.getElementById(MessageToast.CONTAINER_ID)
    if (!container) {
      container = document.createElement("div")
      container.id = MessageToast.CONTAINER_ID
      container.style.cssText = MessageToast.CONTAINER_STYLE
      document.body.appendChild(container)
    }
    return container
  }
}
